<template>
  <div class="chart-box" ref="chartBox" :style="getChartStyle" @click.stop>
    <v-chart
      v-if="showChart && !isEmptyData"
      id="chart"
      class="chart"
      :option="getOption"
      :init-options="getInitOptions"
      @click="dispatchEventCallback('click', $event)"
      @dblclick="dispatchEventCallback('dblclick', $event)"
      @mouseover="dispatchEventCallback('mouseover', $event)"
      @mouseout="dispatchEventCallback('mouseout', $event)"
      @mouseup="dispatchEventCallback('mouseup', $event)"
      @mousedown="dispatchEventCallback('mousedown', $event)"
      @touchstart="dispatchEventCallback('touchstart', $event)"
      @touchend="dispatchEventCallback('touchend', $event)"
      ref="line"
      theme="ovilia-green"
      autoresize
    />
    <!-- 空数据 -->
    <div class="null-data" v-if="isEmptyData">
      <img src="../../../../assets/images/img-null-data-light.png" alt="" />
      <p v-if="errorCode" class="textColor">{{ errorCode }}报错</p>
      <p v-else>暂无数据</p>
    </div>
  </div>
</template>

<script>
import parentMixin from "components/bigScreenComponents/base"
import plugins from "./plugin"
import handleChartData from "utils/updateData/chart/handleChartData.js"
import { hasProperty } from "utils"

export default {
  mixins: [parentMixin, plugins, handleChartData],
  name: "cxLine",
  data() {
    return {
      autoPlayToolTipTimer: null,
      tooltipIndex: 0,
      eventCallbackList: {
        click: [],
        dblclick: ["eventControl.mouseout"],
        mouseover: [],
        mouseout: [],
        mouseup: [],
        mousedown: [],
        touchstart: [],
        touchend: []
      }
    }
  },
  watch: {
    "options.chartOption.series": function (newVal, oldVal) {
      console.log("newVal :>>", newVal)
      // // 动态生成面积图背景
      // newVal.forEach(item => {
      //   if (!item.showAreaStyle) {
      //     item.areaStyle.color = "rgba(0,0,0,0)"
      //     return
      //   }
      //   item.areaStyle.color =
      //     item.areaColorType === "纯色"
      //       ? item.areaColor
      //       : new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      //           { offset: 0, color: `${item.areaStartColor}` },
      //           { offset: 1, color: `${item.areaEndColor}` }
      //         ])
      // })
      if (newVal.length !== oldVal.length) {
        this.$refs.line.setOption(this.options.chartOption, true)
      } else if (newVal[0].animationDuration !== oldVal[0].animationDuration) {
        console.log("初始化")
        this.initOption = this.options.initOptions
      }
      // 解决编辑页数据少于预览页时自定义展示数量不生效的问题
      if (this.isBigScreenPreview()) {
        this.$nextTick(() => {
          this.changeDatazoomFunc(this.options.chartOption.dataZoomSet)
        })
      }
      if(this.options.numberCount){
        this.checkFormatterValue()
      }
    },
    getDragStatus(newVal, oldVal) {
      this.getDragStatusHandle(newVal, oldVal, "line")
    },
    isAutoPlayToolTip(newVal, oldVal) {
      setTimeout(() => {
        this.autoplayTooltip()
      }, 1000)
    },
    autoPlayToolTipIntervalTime(newVal, oldVal) {
      if (this.isAutoPlayToolTip) {
        setTimeout(() => {
          this.autoplayTooltip()
        }, 500)
      }
    },
    showChart() {
      setTimeout(() => {
        this.autoplayTooltip()
      }, 500)
    },
    refreshedChart(newVal) {
      if (newVal) {
        this.$refs.line?.setOption(this.getOption)
        setTimeout(() => {
          this.autoplayTooltip()
        }, 500)
      } else {
        this.$refs.line?.clear()
      }
    },
    "options.chartOption.dataZoomSet": {
      deep: true,
      handler(newVal, oldVal) {
        this.changeDatazoomFunc(newVal, oldVal)
      }
    }
  },
  mounted() {
    this.refreshFunc()
    this.autoplayTooltip()
    this.scrollBarAuto()
    const chartOption = this.options.chartOption
    this.checkFormatterValue()
    if (
      chartOption?.series?.length === 0 ||
      (chartOption?.xAxis?.type === "category" && chartOption?.xAxis?.data?.length === 0) ||
      (chartOption?.yAxis?.type === "category" && chartOption?.yAxis?.data?.length === 0) ||
      (chartOption?.radiusAxis?.type === "category" && chartOption?.radiusAxis?.data?.length === 0) ||
      (chartOption?.series?.length !== 0 && chartOption?.series[0]?.data?.length === 0)
    ) {
      this.hasData = false
    }
  },
  destroyed() {
    clearInterval(this.autoPlayToolTipTimer)
    this.autoPlayToolTipTimer = null
  },
  methods: {
    /*initinePlugin(opt) {
      const plugins = [...this.options.chartOption.pluginName].filter(it => it.trim().length)
      plugins.forEach(pluginName => {
        if (hasProperty(this, pluginName) && typeof this[pluginName] === "function") {
          this[pluginName](opt)
        }
      })
    },*/
    autoplayTooltip() {
      clearInterval(this.autoPlayToolTipTimer)
      this.autoPlayToolTipTimer = null
      if (!this.options.isAutoPlayToolTip) {
        return
      }
      // 自动播放 tooltip 初始化
      let myChart = this.$refs.line?.chart
      let data = this.getOption.series[0].data
      this.autoPlayToolTipTimer = setInterval(() => {
        myChart._api.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: this.tooltipIndex
        })
        this.tooltipIndex++
        if (this.tooltipIndex > data.length - 1) {
          this.tooltipIndex = 0
        }
      }, this.options.autoPlayToolTipIntervalTime)
    }
  }
}
</script>

<style scoped>
.chart {
  height: 100%;
}
</style>
